module.exports={render:function (){
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.user && _vm.user.isDeveloper) ? _c('li', {
    staticClass: "main-menu__item"
  }, [_c('router-link', {
    class: ( _obj = {}, _obj[_vm.settingsLinkActiveClass] = ['Overview', 'ModulesOverview'].indexOf(_vm.settingLink) + 1, _obj ),
    attrs: {
      "to": {
        name: 'Overview'
      }
    }
  }, [_c('span', [_vm._v("Свойства, сущности и действия модулей")])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44bb6b81","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/module/menus/SettingsMenu.vue
// module id = 1123
// module chunks = 0